import { For, Show } from "solid-js";
import { monsterImage, normalizedLevel } from "./studentPresentation";

const layers: Record<number, { float: number; star: number }> = {
  0: { float: 0, star: 10 }, 1: { float: 0, star: 11 }, 2: { float: 3, star: 14 },
  3: { float: 2, star: 10 }, 4: { float: 2, star: 10 }, 5: { float: 2, star: 14 },
  6: { float: 3, star: 6 }, 7: { float: 2, star: 12 }, 8: { float: 2, star: 14 },
  9: { float: 3, star: 16 }, 10: { float: 6, star: 13 }
};

export function MonsterArtwork(props: { level?: number | null; alt: string; layered?: boolean; class?: string }) {
  const level = () => normalizedLevel(props.level);
  const manifest = () => layers[level()];
  const base = () => `/img/monster-levels/level-${level()}`;
  return (
    <Show when={props.layered} fallback={<img src={monsterImage(level())} alt={props.alt} class={`monster-sprite ${props.class ?? ""}`} />}>
      <div class={`monster-layers ${props.class ?? ""}`}>
        <img src={`${base()}/dust.png`} class="monster-layer layer-dust" alt="" />
        <For each={Array.from({ length: manifest().float }, (_, index) => index + 1)}>{(index) => <img src={`${base()}/float-${index}.png`} class={`monster-layer layer-float layer-float-${index}`} alt="" />}</For>
        <For each={Array.from({ length: manifest().star }, (_, index) => index + 1)}>{(index) => <img src={`${base()}/star-${index}.png`} class={`monster-layer layer-star layer-star-${index}`} alt="" />}</For>
        <img src={`${base()}/body.png`} class={`monster-layer layer-body ${level() >= 7 ? "anim-float" : "anim-wobble"}`} alt={props.alt} />
      </div>
    </Show>
  );
}
